import React from 'react';
import { FormattedMessage } from 'react-intl';

const SupportText = () => (
  <div
    css={`
      text-align: center;
      margin-top: 15px;
      color: #ffffff;
      font-family: ${(props) => props.theme.fontFamily};
    `}
  >
    <FormattedMessage defaultMessage="Can we help you? Call our support at +49 30 208 98 63 30" />
  </div>
);

export default SupportText;
